module.exports = __webpack_public_path__ + "static/media/400053_02.55309a2a.png";